import { render } from "./ModuleMainMenu.vue?vue&type=template&id=219c9c02"
import script from "./ModuleMainMenu.vue?vue&type=script&lang=js"
export * from "./ModuleMainMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__